import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { AddonsStateModel } from './addons.model'
import { GetAddonsSummary } from './addons.actions'
import { AddonsService } from '../addons.service'

@State<AddonsStateModel>({
  name: 'addons'
})
@Injectable()
export class AddonsState {
  constructor(private addonsService: AddonsService) {}

  @Selector()
  static summaryResponse(state: AddonsStateModel) {
    return state.summaryResponse
  }

  @Action(GetAddonsSummary)
  getAddonsSummary(ctx: StateContext<AddonsStateModel>, { payload }: GetAddonsSummary) {
    ctx.patchState({
      summaryResponse: undefined
    })
    return this.addonsService.getAddonsSummary(payload).pipe(
      tap((res) => {
        ctx.patchState({
          summaryResponse: res
        })
      })
    )
  }
}
